import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { resolveStoreKey } from '../constants/stores';

/**
 * „Melyik üzlet készülékét nézi ÉPPEN a látogató?”
 *
 * A sticky mobil sáv (MobileCTABar) az oldalfa tetején ül, a terméklap és a
 * terméklista-modál viszont mélyen a Routes alatt – közvetlenül nem tudnak
 * egymásról. Enélkül a sáv „Hívás” gombja mindig a Belvárost hívta, akkor is,
 * ha a látogató épp egy Tescóban lévő készüléket nézett: a hívás abba az
 * üzletbe futott be, ahol a készülék nincs is.
 *
 * A kontextus SZÁNDÉKOSAN csak a bolt kulcsát tartja (nem a teljes készüléket):
 * ennyi kell a helyes telefonszámhoz, és nem lesz belőle második, a
 * komponensekkel versengő állapottár.
 */
const ActiveStoreContext = createContext({
  activeStoreKey: null,
  setActiveStoreKey: () => {},
});

export function ActiveStoreProvider({ children }) {
  const [activeStoreKey, setActiveStoreKey] = useState(null);
  const value = useMemo(() => ({ activeStoreKey, setActiveStoreKey }), [activeStoreKey]);
  return <ActiveStoreContext.Provider value={value}>{children}</ActiveStoreContext.Provider>;
}

/** Az aktív bolt kulcsa ('belvaros' | 'tesco' | null). */
export const useActiveStoreKey = () => useContext(ActiveStoreContext).activeStoreKey;

/**
 * Beállítja az aktív boltot, amíg a hívó komponens (vagy a megnyitott modál)
 * él, és kilépéskor VISSZAÁLLÍTJA null-ra – így a terméklapról elnavigálva a
 * sáv magától visszatér a fő számra. Bármilyen nyers bolt-értéket elfogad
 * (kulcs, office-kód, emberi címke), a feloldás a constants/stores.js dolga.
 */
export function useActiveStoreEffect(rawStore) {
  const { setActiveStoreKey } = useContext(ActiveStoreContext);
  const key = resolveStoreKey(rawStore);
  useEffect(() => {
    setActiveStoreKey(key);
    return () => setActiveStoreKey(null);
  }, [key, setActiveStoreKey]);
}
